import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-test-id": "label"
}
const _hoisted_2 = ["value", "type"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-80 flex flex-col", _ctx.containerClassName])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["relative flex items-center", { 'mt-3': _ctx.label !== undefined }])
    }, [
      _createElementVNode("input", _mergeProps(_ctx.$attrs, {
        class: ["flex-1 p-3 shadow-2xl rounded-lg focus:outline-none", _ctx.className]
      }, {
        value: _ctx.value,
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.update && _ctx.update(...args))),
        type: _ctx.showPassword ? 'text' : _ctx.type,
        "data-test-id": "input"
      }), null, 16, _hoisted_2),
      (_ctx.showHideIcon)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "absolute top-2/4 transform -translate-y-2/4 right-2 cursor-pointer",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.togglePassword && _ctx.togglePassword(...args))),
            "data-test-id": "password"
          }, [
            (_ctx.showPassword)
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 0,
                  "data-test-id": "reveal",
                  name: "reveal"
                }))
              : (_openBlock(), _createBlock(_component_v_icon, {
                  key: 1,
                  "data-test-id": "revealHide",
                  name: "revealHide"
                }))
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}